import { IOffer } from '../../offer';
import { TThunkAction, TThunkDispatch } from '../../types/redux';
import { ITypedReduxAction } from '../../types/redux/actionType';
import { actionGenerator } from '../../utils/redux/actionGenerator';

export enum EChatActionTypes {
  Open = 'Chat/Open',
  Close = 'Chat/Close',
}

type TOpenChatPayload = {
  offer: IOffer;
  position: number;
};

export type TOpenChat = ITypedReduxAction<EChatActionTypes.Open, TOpenChatPayload>;
export type TCloseChat = ITypedReduxAction<EChatActionTypes.Close>;

/**
 * Action открытия чата
 * @param TOpenChatPayload
 */
export const openChat: (payload: TOpenChatPayload) => TOpenChat = actionGenerator<
  EChatActionTypes.Open,
  TOpenChatPayload
>(EChatActionTypes.Open);

/**
 * Callback авторизации при попытке открыть чаты
 * @param TOpenChatPayload
 */
export const onChatSuccessAuth = (payload: TOpenChatPayload) => (): TThunkAction => (dispatch: TThunkDispatch) =>
  dispatch(openChat(payload));

/**
 * Action закрытия чата
 */
export const closeChat: () => TCloseChat = actionGenerator<EChatActionTypes.Close>(EChatActionTypes.Close);

export type TChatActions = TOpenChat | TCloseChat;
